const config = {
  randomApiKey: '22ce6052-4543-4b6f-afb0-9524ef7e952c',
  randomApiUrl: 'https://api.random.org/json-rpc/2/invoke',
  randomSampleSize: 100,
  rollHistoryStackSize: 100,
  firebaseConfig: {
    apiKey: "AIzaSyDGklPwmanwXmyx3DSo9AGK20ctLt1wefo",
    authDomain: "dnd-box.firebaseapp.com",
    databaseURL: "https://dnd-box.firebaseio.com",
    projectId: "dnd-box",
    storageBucket: "dnd-box.appspot.com",
    messagingSenderId: "336600215211",
    appId: "1:336600215211:web:fbc565ebc5bd98fed051ee"
  }
};

export default config;
